import { Component } from '@angular/core';
import { MsalService } from '@azure/msal-angular';

@Component({
  selector: 'app-login',
  template: ''
})
export class AppLoginComponent {

  async ngOnInit() {
    await this.login();
  }

  constructor(private msalService: MsalService) {
  }

  async login() {
      await this.msalService.loginRedirect();
  }
}
